import { render, staticRenderFns } from "./ProductPurchaseFreeAction.vue?vue&type=template&id=2bf05ff5&"
import script from "./ProductPurchaseFreeAction.vue?vue&type=script&lang=js&"
export * from "./ProductPurchaseFreeAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports